export function PublicProfileActionsFallback() {
  return (
    <div className="flex items-center gap-2" aria-hidden="true">
      <div className="h-8 w-[6.5rem] animate-pulse rounded-lg bg-surface-alt" />
      <div className="size-8 animate-pulse rounded-lg bg-surface-alt" />
    </div>
  );
}
